import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import cn from 'classnames';
import Button from '../Button';
import Portal from '../Portal';
import Icon from '../Icon';
import { TOAST_ICON_MAP } from './types';
import { EE } from './toaster-emitter';
import styles from './ToasterManager.module.scss';
const handler = ({ onConfirm, onCancel, title, status, type = 'dark', confirmText = 'Confirm', cancelText = 'Cancel', description, closeIcon = true, autoClose, ...restProps }) => toast(({ closeToast }) => {
    const handleClose = () => {
        closeToast?.();
    };
    const _onConfirm = () => {
        closeToast?.();
        onConfirm?.();
    };
    const _onCancel = () => {
        closeToast?.();
        onCancel?.();
    };
    return (_jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.header, children: [status && (_jsx("div", { className: cn(styles.status, styles[status]), children: _jsx(Icon, { name: TOAST_ICON_MAP[status], size: 19 }) })), _jsxs("div", { className: styles.textContent, children: [title, description && _jsx("div", { className: styles.description, children: description })] }), closeIcon && (_jsx("div", { children: _jsx(Icon, { name: "ic_close", size: 16, onClick: handleClose }) }))] }), (onCancel || onConfirm) && (_jsxs("div", { className: cn(styles.actions, { [styles.autoClose]: autoClose }), children: [onCancel && (_jsx(Button, { onClick: _onCancel, color: type === 'default' ? 'typography' : 'background', ghost: true, children: cancelText })), onConfirm && _jsx(Button, { onClick: _onConfirm, children: confirmText })] }))] }));
}, { ...restProps, className: styles[type], closeButton: false, autoClose });
const ToasterManager = ({ event = 'TOASTER', className }) => {
    useEffect(() => {
        EE.on(event, handler);
        return () => {
            EE.removeListener(event, handler);
        };
    });
    return (_jsx(Portal, { children: _jsx(ToastContainer, { className: cn(styles.container, className), position: "bottom-center" }) }));
};
export default ToasterManager;
